// Education module shown between the pre-test and post-test. Content is derived
// from the study's verified answer key (ADA 2019, AHA 2021, Cochrane reviews).
// Keep it concise and guideline-anchored; expand freely.

export const educationModules = [
  {
    id: 'amr-basics',
    title: 'Why AMR is a dental problem',
    points: [
      'Antimicrobial resistance (AMR) is a leading global health threat; up to ~10 million deaths/year are projected by 2050 if unchecked.',
      'Dentistry accounts for roughly 10% of human antibiotic prescriptions — and a large share is unnecessary.',
      'Antibiotics work on bacteria, not viruses; sub-therapeutic dosing and unnecessary use both drive resistance.',
    ],
    tip: 'Antibiotics kill bugs, not pain — and ~10% of all antibiotics come from dentistry, much of it avoidable.',
  },
  {
    id: 'when-not-needed',
    title: 'When antibiotics are NOT needed',
    points: [
      'Symptomatic irreversible pulpitis → pulpectomy/RCT or extraction + analgesics. No antibiotic.',
      'Localised acute apical abscess (no systemic signs) → incision & drainage / endodontic treatment. No antibiotic.',
      'Alveolar osteitis (dry socket) → irrigation + medicated dressing + analgesia. It is not a bacterial infection — no antibiotic.',
      'Principle: definitive operative treatment is first-line; antibiotics never substitute for it.',
    ],
    tip: 'Drill, don’t pill: pulpitis, localised abscess and dry socket are treated operatively — no antibiotic.',
  },
  {
    id: 'when-needed',
    title: 'When antibiotics ARE needed',
    points: [
      'Acute apical abscess WITH systemic involvement (fever, facial cellulitis, lymphadenopathy, trismus) or in immunocompromised patients.',
      'Give as an adjunct to drainage — first-line amoxicillin (e.g., 500 mg TID, ± 1 g loading), shortest effective course, reassess at 3 days.',
    ],
    tip: 'Reach for antibiotics only when it spreads or the patient is systemically unwell — and always alongside drainage.',
  },
  {
    id: 'ie-prophylaxis-2021',
    title: 'Endocarditis prophylaxis — the 2021 way',
    points: [
      'Only for highest-risk hearts (prosthetic valve/material, previous IE, specified congenital disease, cardiac-transplant valvulopathy) AND procedures that manipulate gingiva/periapex or perforate oral mucosa.',
      'Standard: amoxicillin 2 g (adult) / 50 mg/kg (child), single dose 30–60 min before.',
      'Penicillin allergy: cephalexin 2 g, OR azithromycin/clarithromycin 500 mg, OR doxycycline 100 mg.',
      'Important change: CLINDAMYCIN is no longer recommended for endocarditis prophylaxis (removed in 2021). Avoid cephalosporins if there is penicillin anaphylaxis.',
    ],
    tip: 'Highest-risk hearts only: amoxicillin 2 g, 30–60 min before. And remember — clindamycin is OUT (2021).',
  },
  {
    id: 'stewardship',
    title: 'Five stewardship habits',
    points: [
      'Diagnose first; treat the cause operatively.',
      'Prescribe only with a clear indication; prefer narrow-spectrum.',
      'Right drug, dose, duration; document the indication.',
      'Resist patient pressure for unnecessary antibiotics.',
      'Keep up with current guidelines (ADA 2019, AHA 2021).',
    ],
    tip: 'The 4 D’s: right Drug, right Dose, right Duration — and Document the indication.',
  },
];
